import { useClientConfiguration, type ProductConfiguration } from "../data/global/useProductConfiguration";

type FootnoteType = "hcpLandscape" | "payerLandscape";

const useHasFootnote = (client: string, type?: FootnoteType) => {
  const config: ProductConfiguration = useClientConfiguration(client);

  if (!type) {
    // Return legacy behavior for backward compatibility
    return config.showFootnote;
  }

  // ProductConfiguration now includes landscape-specific footnote flags.
  if (type === "hcpLandscape") {
    return config.showHcpLandscapeFootnote !== undefined ? config.showHcpLandscapeFootnote : config.showFootnote;
  }

  if (type === "payerLandscape") {
    return config.showPayerLandscapeFootnote !== undefined ? config.showPayerLandscapeFootnote : config.showFootnote;
  }

  // Fallback to default footnote setting
  return config.showFootnote;
};

export default useHasFootnote;
